export class TokenRequestViewModel {
  public Source: string;
  public UserName: string;
  public Password: string;
  public Key: string;
}
